import { useCallback, useEffect, useState } from 'react'

export function useDocumentsPickerSelection(open, maxSelectable) {
  const [selectedIds, setSelectedIds] = useState(() => new Set())

  useEffect(() => {
    if (open) setSelectedIds(new Set())
  }, [open])

  const onToggleSelect = useCallback(
    (id) => {
      setSelectedIds((prev) => {
        const next = new Set(prev)
        if (next.has(id)) {
          next.delete(id)
          return next
        }
        if (next.size >= maxSelectable) return prev
        next.add(id)
        return next
      })
    },
    [maxSelectable],
  )

  return { selectedIds, onToggleSelect, selectedCount: selectedIds.size }
}
